import React, { ReactNode } from 'react';
import { BaseModal, BaseModalProps } from './BaseModal';

export interface ContentModalProps extends BaseModalProps {
  footer?: ReactNode;
}

export const ContentModal: React.FC<ContentModalProps> = ({
  footer,
  children,
  ...baseProps
}) => {
  return (
    <BaseModal
      {...baseProps}
      footer={footer}
      contentClassName={baseProps.contentClassName ?? 'p-6'}
    >
      {children}
    </BaseModal>
  );
};
